/* eslint-disable */
import React, { useState } from "react";
import { Box, Button, CircularProgress, MenuItem, Select, TextField, Typography, Tooltip } from "@mui/material";
import { Counts } from "../../utils/myUtills";
import languages from "../../utils/languages";

const GenerateKeyword = ({
  titles,
  setFormState,
  checkError,
  setErrorState,
  formState,
  errorState,
  generateTitle,
  setTitles,
  setActiveStep,
  handleOpen,
  handleState,
  handleTitleGenerate,
  navigate,
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const handleInputChange = e => {
    const { name, value } = e.target;

    if (name === "keyword") {
      const valueStr = String(value);
      const commaCount = (valueStr.match(/,/g) || []).length;
      const keywordsArray = valueStr
        .split(",")
        .map(kw => kw.trim())
        .filter(Boolean);
      if (/[^a-zA-Z,\s]/.test(valueStr)) {
        setErrorState(prev => ({
          ...prev,
          [name]: "Only alphabetical characters are allowed",
        }));
        setIsButtonDisabled(true);
        return;
      }

      if (commaCount > 2 || keywordsArray.length > 3) {
        setErrorState(prev => ({
          ...prev,
          [name]: "You are allowed only 3 keywords",
        }));
        setIsButtonDisabled(true);
        return;
      } else {
        setErrorState(prev => ({ ...prev, [name]: "" }));
      }

      setIsButtonDisabled(valueStr.trim() === "");
    }

    setFormState(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Box className="GenerateKeywordBox">
      <Box className="rankingContent">
        <Typography
          component="h2"
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            width: "100%",
            display: "block",
            marginBottom: "16px",
          }}
        >
          Guidelines
        </Typography>
        <Box
          component="ul"
          sx={{
            listStyleType: "disc",
            paddingLeft: "20px",
            marginTop: "16px",
            marginBottom: "16px",
            "& li": { marginBottom: "20px", "&:last-of-type": { marginBottom: "0" } },
          }}
        >
          <Typography component="li">
            You can enter <strong>multiple keywords</strong> separated by commas.
          </Typography>
          <Typography component="li">
            Maximum of <strong>3 keywords</strong> can be entered.
          </Typography>
          <Typography component="li">
            You can choose any <strong>language</strong> for the titles.
          </Typography>
          <Typography component="li">
            You can select the <strong>quantity</strong> of titles you wish to generate.
          </Typography>
          <Typography component="li">
            The maximum <strong>quantity</strong> of titles you can generate is <strong>5</strong>.
          </Typography>
        </Box>
      </Box>
      <Box className="KeywordInputBoxes">
        <Box className="inputBox">
          <Typography component="label">Keyword</Typography>
          <TextField
            name="keyword"
            value={formState.keyword}
            onChange={handleInputChange}
            className="inputField"
            placeholder="Enter up to 3 keywords (e.g. apple, banana, orange)"
            error={!!errorState.keyword}
            helperText={errorState.keyword}
            disabled={formState.loading}
          />
        </Box>
        <Box className="SelectInputBoxes">
          <Typography component="label">Language</Typography>
          <Select
            name="language"
            defaultValue="English"
            value={formState.language}
            onChange={handleInputChange}
            className="selectBox"
            sx={{ minWidth: 120 }}
            disabled={formState.loading}
          >
            {languages.map((item, index) => (
              <MenuItem key={index} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box className="SelectInputBoxes">
          <Typography component="label">Quantity</Typography>
          {/* <Tooltip title="Select the title quantity to get generated" arrow placement="top">
            <Typography component="label" sx={{ cursor: "help" }}>
              Quantity
            </Typography>
          </Tooltip> */}
          <Tooltip title="Select the number of page titles to generate." arrow placement="top">
            <Select name="count" value={formState.count} onChange={handleInputChange} className="selectBox" sx={{ minWidth: 80 }} disabled={formState.loading}>
              {Counts.map(qty => (
                <MenuItem key={qty} value={qty}>
                  {qty}
                </MenuItem>
              ))}
            </Select>
          </Tooltip>
        </Box>
        <Button
          className="GenerateBtn"
          onClick={e =>
            handleTitleGenerate({
              e,
              isRegenerate: false,
              formState,
              setFormState,
              generateTitle,
              titles,
              setTitles,
              setActiveStep,
              handleOpen,
              checkError,
              handleState,
              navigate,
              type: "title",
            })
          }
          disabled={formState.loading || isButtonDisabled}
        >
          {formState.loading ? <CircularProgress className="loaderBox" /> : "Generate"}
        </Button>
      </Box>
    </Box>
  );
};

export default GenerateKeyword;
